import { FC, useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import {
  TextInput,
  AutocompleteDropDown,
  ReferenceDropDown,
  PhoneLandInput,
} from "../../../components";
import { Button, Divider, Grid, Alert } from "@mui/material";
import {
  fetcher,
  lineOptions,
  newTypeOptions,
  params,
  paymentTypeOptions,
  voiceProductTypeOptions,
} from "../../../utils";
import {
  lineEnum,
  newTypeEnum,
  paymentTypeEnum,
  paymentVoiceTypeEnum,
  productCategoryEnum,
} from "../../../utils/enum";
import StaticIp from "./common/StaticIp";
import Swal from "sweetalert2";
import useLocales from "../../../hooks/useLocales";
import ThkInputs from "./common/ThkInputs";
import OrderLines from "./common/OrderLines";
import OrderLineAdd from "./common/OrderLineAdd";
import AutocompleteInput from "../../../components/inputs/Autocomplete";
import { useAppDispatch } from "../../../app/hooks";
import { ApiSlice } from "../../../features/api/Api";
import { PhoneNumberForInternetFttx } from "./common";
import { ConnectServiceAddress } from "./common/setAddressesValue";
import InternetFrastructureView from "./common/InternetFrastructureView";

const ServiceCreate: FC = () => {
  const { t } = useTranslation();
  const [selectedLine, setSelectedLine] = useState<any | null>(null);
  const { translate } = useLocales();
  const formik: any = useFormikContext();
  const dispatch = useAppDispatch();
  const [options, setOptions] = useState<any>([]);
  const [openAddress, setOpenAddress] = useState(false);
  const handleOpenAddress = () => setOpenAddress(true);
  const handleCloseAddress = () => setOpenAddress(false);

  useEffect(() => {
    const newTypeId = newTypeOptions.find(
      (item) => item.value === formik?.values?.newType
    )?.id;
    formik.setFieldValue("internetTypeId", newTypeId);
    const productTypeName = voiceProductTypeOptions.find(
      (item) => item.value === formik?.values?.productTypeId
    )?.label;
    formik.setFieldValue("productName", productTypeName);
  }, [formik.values]);

  const getVoiceCampaign = async () => {
    const result = await dispatch(
      ApiSlice.endpoints.getList.initiate({
        resource: `fixity/catalog/voicePackage`,
        params: {
          ...params,
          filter: {
            merlinProductTypeId: formik?.values.productTypeId,
          },
        },
      })
    );
    const { data: productVoice }: any = result;

    if (productVoice.data.length > 0) {
      const campaignOptions = productVoice?.data?.map((item: any) => ({
        value: item.name,
        label: item.name,
      }));
      setOptions(campaignOptions);
      const setCampaignName = productVoice?.data?.find(
        (item: any) => item.name === formik.values.campaign
      ).name;
      formik.setFieldValue("campaignName", setCampaignName);
    }
  };
  useEffect(() => {
    if (formik?.values.categoryId === productCategoryEnum.voiceService) {
      getVoiceCampaign();
    }
  }, [formik.values]);
  return (
    <Grid container spacing={3} style={{ marginTop: "50px" }}>
      <Grid item md={12}>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <StaticIp />
          </Grid>
          <Grid item md={6}>
            <ReferenceDropDown
              name="categoryId"
              label="Ürün/Hizmet Kategorisi"
              reference="fixity/catalog/variant/get-merlin-product-groups"
              optionName="name"
              query={{
                isDeleted: false,
                ...{ codes: ["SES", "INT"] },
              }}
              secondField={{ name: "categoryName", value: "name" }}
            />
          </Grid>
          {formik?.values?.categoryId === 7 ? (
            <Grid item md={6}>
              <AutocompleteDropDown
                label="Ürün/Hizmet Tipi"
                name="productTypeId"
                options={voiceProductTypeOptions}
              />
            </Grid>
          ) : null}
          <Grid item md={6}>
            <AutocompleteDropDown
              label={t("tabs.service.paymentType")}
              name="paymentType"
              options={paymentTypeOptions}
            />
          </Grid>
          {Number(formik?.values?.categoryId) ===
          productCategoryEnum.voiceService ? (
            <Grid item md={6}>
              <AutocompleteInput
                name="campaign"
                label={t("tabs.service.serviceProduct")}
                options={options}
              />
            </Grid>
          ) : null}
          {(formik.values?.categoryId === productCategoryEnum.connectService &&
            formik?.values?.paymentType === paymentTypeEnum.new) ||
          (formik?.values?.categoryId === productCategoryEnum.voiceService &&
            formik?.values?.productTypeId === paymentVoiceTypeEnum.thk &&
            formik?.values?.paymentType === paymentTypeEnum.new) ? (
            <Grid item md={12} style={{ textAlign: "center" }}>
              <Divider />
              <Button
                variant="contained"
                onClick={handleOpenAddress}
                style={{ height: 50, margin: "15px 0", width: "200px" }}
              >
                Adres Ekle
              </Button>
              <Divider />
              <ConnectServiceAddress
                handleOpen={handleOpenAddress}
                handleClose={handleCloseAddress}
                open={openAddress}
                setOpenAddress={setOpenAddress}
              />
              {!openAddress ? <InternetFrastructureView /> : null}
            </Grid>
          ) : null}

          {formik?.values?.categoryId === productCategoryEnum.connectService &&
          Number(formik?.values?.paymentType) === paymentTypeEnum.new ? (
            <Grid item md={6}>
              <AutocompleteDropDown
                label="İnternet Tipi"
                name="newType"
                options={newTypeOptions}
              />
            </Grid>
          ) : null}

          {Number(formik?.values?.categoryId) ===
            productCategoryEnum.connectService &&
          formik?.values.paymentType === paymentTypeEnum.new ? (
            <Grid item md={6}>
              {/* <AutocompleteInput
                name="campaign"
                label={t("tabs.service.serviceProduct")}
                options={options}
              /> */}
              <ReferenceDropDown
                name="campaign"
                label="Kampanya/Tarifeler"
                reference="fixity/catalog/variant/get-variant-by-max-speed"
                query={{
                  internetType:
                    formik.values.newType === newTypeEnum.lean_internet ||
                    formik.values.newType === newTypeEnum.lean_internet_fiber
                      ? "7e04f63f-5be8-4cde-cc8a-08dbe98f32fc"
                      : "c2865226-a719-4a4d-cc89-08dbe98f32fc",
                  speed: formik.values.addressInternetSpeed,
                  variantStatusId: 1,
                }}
                optionName="customerVariantName"
                secondField={{
                  value: "customerVariantName",
                  name: "campaignName",
                }}
              />
            </Grid>
          ) : null}

          {formik?.values?.categoryId === productCategoryEnum.connectService &&
          Number(formik?.values?.paymentType) === paymentTypeEnum.churn ? (
            <Grid item md={6}>
              <AutocompleteDropDown
                label="Churn Tipi"
                name="hatType"
                options={lineOptions}
              />
            </Grid>
          ) : null}
          {Number(formik?.values?.categoryId) ===
            productCategoryEnum.connectService &&
          formik?.values.paymentType === paymentTypeEnum.churn ? (
            <Grid item md={6}>
              {/* <AutocompleteInput
                name="campaign"
                label={t("tabs.service.serviceProduct")}
                options={options}
              /> */}
              <ReferenceDropDown
                name="campaign"
                label="Kampanya/Tarifeler"
                reference="fixity/catalog/variant/get-variant-by-max-speed"
                query={{
                  internetType:
                    formik.values.hatType === lineEnum.lean_line
                      ? "7e04f63f-5be8-4cde-cc8a-08dbe98f32fc"
                      : "c2865226-a719-4a4d-cc89-08dbe98f32fc",
                  speed: formik.values.addressInternetSpeed,
                  variantStatusId: 1,
                }}
                optionName="customerVariantName"
                secondField={{
                  value: "customerVariantName",
                  name: "campaignName",
                }}
              />
            </Grid>
          ) : null}
        </Grid>
      </Grid>

      {formik?.values?.categoryId === productCategoryEnum.connectService &&
        Number(formik?.values?.paymentType) === paymentTypeEnum.new && (
          <>
            {(Number(formik?.values?.newType) === newTypeEnum.internet ||
              Number(formik?.values?.newType) === newTypeEnum.inter_fttx) && (
              <PhoneNumberForInternetFttx />
            )}
          </>
        )}

      {formik?.values?.categoryId === productCategoryEnum.connectService &&
        Number(formik?.values?.paymentType) === paymentTypeEnum.churn && (
          <>
            {Number(formik?.values?.hatType) === lineEnum.fixed_line && (
              <Grid item md={4}>
                <PhoneLandInput
                  name="servicePhone"
                  label={t("land_phone")}
                  handleChange={function (e: any) {
                    formik?.setFieldValue(
                      "servicePhone",
                      e.target.value.replace(/\D/g, "") // removes all non-numeric characters
                    );
                    if (e.target.value.replace(/\D/g, "").length === 10) {
                      fetcher(
                        `fixity/order/order/get-xdsl-or-pstn?pstn=${e.target.value.replace(
                          /\D/g,
                          ""
                        )}`,
                        "GET",
                        null
                      ).then((data) => {
                        if (data.isSuccessful) {
                          formik?.setFieldValue("devreNo", data.data);
                        } else {
                          Swal.fire(
                            translate("actions.error"),
                            data.data,
                            "error"
                          );
                        }
                      });
                    }
                  }}
                />
              </Grid>
            )}
          </>
        )}
      {formik?.values?.categoryId === productCategoryEnum.voiceService &&
      Number(formik.values?.productTypeId) === paymentVoiceTypeEnum.thk ? (
        <ThkInputs />
      ) : null}
      {formik?.values?.categoryId === productCategoryEnum.voiceService &&
      (Number(formik.values?.productTypeId) === paymentVoiceTypeEnum.voip ||
        Number(formik.values?.productTypeId) ===
          paymentVoiceTypeEnum.sanal_santral) ? (
        <ThkInputs />
      ) : null}
      {formik?.values?.categoryId === productCategoryEnum.connectService &&
      Number(formik?.values?.paymentType) === paymentTypeEnum.churn ? (
        <>
          <Grid item md={4}>
            <TextInput name="devreNo" label={t("devreNo")} />
          </Grid>
          {/*  <Grid item md={4}>
            <InvoiceGroupInput name="invoiceGroupId" />
          </Grid> */}
        </>
      ) : null}
      {/* {Number(formik.values.categoryId) === productCategoryEnum.voiceService &&
      Number(formik.values.productTypeId) === paymentVoiceTypeEnum.thk &&
      Number(formik.values.paymentType) === paymentTypeEnum.new ? (
        <>
          <Grid item md={6}>
              <InvoiceGroupInput name="invoiceGroupId" />
          </Grid>
        </>
      ) : null} */}

      {/* {Number(formik.values.categoryId) === productCategoryEnum.voiceService &&
      Number(formik.values.productTypeId) === paymentVoiceTypeEnum.thk &&
      Number(formik.values.paymentType) === paymentTypeEnum.new ? (
        <>
          <Grid item md={12} style={{ textAlign: "center" }}>
            <Divider />
            <Button
              variant="contained"
              onClick={handleOpen}
              style={{ height: 50, margin: "15px 0", width: "200px" }}
            >
              Adres Ekle
            </Button>
            <Divider />
          </Grid>
          <Grid item md={12}>
            <InternetAddressCreate
              setOpen={setOpen}
              open={open}
              handleClose={handleClose}
            />
          </Grid>
          <GetInternetAddress />
          {formik?.errors?.internetAddresses ? (
            <>
              <Typography variant="subtitle1" color="error">
                {formik?.errors?.internetAddresses}
              </Typography>
            </>
          ) : null}
        </>
      ) : null} */}

      {/* <Grid item md={12}>
        <Grid container spacing={3}>
          <Grid item md={4}>
            <ReferenceArraySelectInput
              name="customerManagementGroupIds"
              label={translate(
                "resources.sales.proposal.ddtech.customerManagementGroupIds"
              )}
              reference="fixity/proposal/DdTech/CustomerProcessManagementGroupList"
              recordname="id"
              optionname="name"
              secondField={[
                {
                  name: "name",
                  value: "name",
                },
                {
                  name: "id",
                  value: "id",
                },
              ]}
              optionId="id"
            />
          </Grid>
          <Grid item md={4}>
            <AutocompleteDropDown
              name="ddtechType"
              label={translate("resources.sales.proposal.ddtech.type")}
              options={locale(
                ddTechOptions,
                "resources.sales.proposal.ddtech.types."
              )}
            />
          </Grid>
        </Grid>
      </Grid> */}
      <OrderLineAdd
        selectedLine={selectedLine}
        setSelectedLine={setSelectedLine}
      />
      <Grid item md={12}>
        {formik?.errors && formik?.errors?.orderLines ? (
          <Alert severity="warning">{formik?.errors?.orderLines}</Alert>
        ) : null}
      </Grid>
      {formik?.values?.orderLines?.length > 0 ? (
        <OrderLines
          selectedLine={selectedLine}
          setSelectedLine={setSelectedLine}
        />
      ) : null}
      <Grid item md={12}>
        <TextInput name="workorderDescription" label="Açıklama" />
      </Grid>
    </Grid>
  );
};

export default ServiceCreate;
